import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useRecoilState } from "recoil";
import { CurrentServiceState, Languege } from "../Atom";
import { fetchAservices, fetchBlog, fetchLogo, fetchTranslates } from "../Services/Requests.js";
import { useQuery } from "@tanstack/react-query";
import { HashLink } from "react-router-hash-link";
import logoBg from "../assets/images/logoBg.png";
import logoBg2 from "../assets/images/logoBg2.png";
import searchIcon from "../assets/images/search.svg";
import hamburger from "../assets/images/hamburger.svg";
import close from "../assets/images/close.svg";

const languages = [
  { code: "ru", name: "Русский", flag: "/svg/ru.svg" },
  { code: "az", name: "Azərbaycan", flag: "/svg/az.svg" },
  { code: "en", name: "English", flag: "/svg/en.svg" },
];

export default function Header({ isBlog = false, ishome = false }) {
  const [sohowAside, setsohowAside] = useState(false);
  const [sohowSech, setsohowSech] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const storedLangCode = localStorage.getItem("Accept-Language");
    return storedLangCode
      ? languages.find((lang) => lang.code === storedLangCode) || languages[0]
      : languages[0];
  });

  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [language, setLanguie] = useRecoilState(Languege);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentService, setCurrentService] = useRecoilState(CurrentServiceState);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleLanguageChange = (lng) => {
    setSelectedLanguage(lng);
    setIsLanguageDropdownOpen(false);
    localStorage.setItem("Accept-Language", lng.code);
    setLanguie(lng.code);
  };

  // İlk renderdə recoil dilini localStorage ilə sync et
  useEffect(() => {
    const storedLangCode = localStorage.getItem("Accept-Language");
    if (storedLangCode) {
      const lng = languages.find((l) => l.code === storedLangCode);
      if (lng) {
        setSelectedLanguage(lng);
        setLanguie(lng.code);
      }
    }
  }, [setLanguie]);

  // Queries
  const { data: Translates } = useQuery({ queryKey: ["Translates", language], queryFn: fetchTranslates });
  const { data: Blog } = useQuery({ queryKey: ["Blog", language], queryFn: fetchBlog });
  const { data: Logo } = useQuery({ queryKey: ["Logo", language], queryFn: fetchLogo });
  const {
    data: Services,
    isLoading: loadingServices,
    error: errorServices,
  } = useQuery({ queryKey: ["Services", language], queryFn: fetchAservices });

  const filteredServices = Services?.data?.filter((service) =>
    service?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );
  const filteredBlogs = Blog?.data?.filter((blog) =>
    blog?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  const handleBlur = () => {
    setTimeout(() => setsohowSech(false), 100);
  };

  // --- FAVICON FIX START ---
  function updateFavicon(rawUrl) {
    if (!rawUrl) return;

    // Relative path-ı absolute URL-ə çevir
    let href;
    try {
      href = new URL(rawUrl, window.location.origin).href;
    } catch {
      href = rawUrl; // artıq absolute-dursa
    }

    // MIME type
    const isIco = href.toLowerCase().endsWith(".ico");
    const type = isIco ? "image/x-icon" : "image/png";

    const rels = ["icon", "shortcut icon"];
    rels.forEach((rel) => {
      let link = document.querySelector(`link[rel='${rel}']`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.type = type;
      // cache-bust (favicon dəyişəndə brauzer təmiz götürsün)
      const bust = href.includes("?") ? "&" : "?";
      link.href = `${href}${bust}v=${Date.now()}`;
    });

    // iOS homescreen üçün
    let apple = document.querySelector("link[rel='apple-touch-icon']");
    if (!apple) {
      apple = document.createElement("link");
      apple.rel = "apple-touch-icon";
      document.head.appendChild(apple);
    }
    apple.href = href;
  }

  // Logo gəldikdən/yeniləndikdən sonra favicon-u qur
  useEffect(() => {
    const fav = Logo?.data?.data?.logo?.fav_icon;
    if (fav) updateFavicon(fav);
  }, [Logo]);
  // --- FAVICON FIX END ---

  if (loadingServices) return <div />;
  if (errorServices) return <div>Error loading data</div>;

  return (
    <>
      <nav className={`navbar ${isBlog ? "blogNav" : ""}`}>
        <div className="nav-inner">
          <div className="mobileAside">
            <div onClick={() => setsohowAside((prew) => !prew)} className="hamburger">
              <img src={sohowAside ? close : hamburger} alt="" />
            </div>
            {sohowAside && (
              <div className="asideLinks">
                <Link to="/" className="asideLinkItem">{Translates?.data?.data?.home}</Link>
                <Link to="/about" className="asideLinkItem">{Translates?.data?.data?.about_us}</Link>
                <Link to="/services" className="asideLinkItem">{Translates?.data?.data?.services}</Link>
                <Link to="/news" className="asideLinkItem">{Translates?.data?.data?.blog}</Link>
                <Link to="/galery" className="asideLinkItem">{Translates?.data?.data?.gallery}</Link>
                <Link to="/contact" className="asideLinkItem">{Translates?.data?.data?.contact}</Link>
              </div>
            )}
          </div>

          <div className="logo-container">
            <Link to="/" className="logo">
              {/* Optional chaining ilə qoruyuruq */}
              <img src={Logo?.data?.data?.logo?.logo} alt="" />
            </Link>
            <img src={isBlog ? logoBg2 : logoBg} alt="" className="logoBg" />
          </div>

          <div className="nav-links">
            <Link to="/">{Translates?.data?.data?.home}</Link>
            <Link to="/about">{Translates?.data?.data?.about_us}</Link>

            <div className="dropMenu">
              <Link to="/services">{Translates?.data?.data?.services}</Link>
              <div className="submenu">
                {Services?.data?.map((item, index) => (
                  <HashLink
                    key={index}
                    to={`/services/#${item?.slug}`}
                    scroll={(el) =>
                      el.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      })
                    }
                    className="section-link"
                  >
                    {item?.title}
                  </HashLink>
                ))}
              </div>
            </div>

            <Link to="/news">{Translates?.data?.data?.blog}</Link>
            <Link to="/galery">{Translates?.data?.data?.gallery}</Link>
            <Link to="/contact">{Translates?.data?.data?.contact}</Link>
          </div>

          <div className="navbar-right">
            <div className="nav-search">
              <div className="search-bar">
                <input
                  type="text"
                  onFocus={() => setsohowSech(true)}
                  onBlur={handleBlur}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="bg-none focus:outline-none w-full"
                  placeholder={"Search"}
                />
                <button className="searchBtn">
                  <img src={searchIcon} alt="" />
                </button>
              </div>

              <div
                style={{
                  ...(sohowSech && searchTerm ? { borderRadius: "8px" } : { display: "none" }),
                  "--scrollbar-width": "4px",
                }}
                className="results"
              >
                {filteredServices?.length > 0 || filteredBlogs?.length > 0 ? (
                  <>
                    {filteredServices?.map((service, index) => (
                      <HashLink
                        key={"service-" + index}
                        to={`/services/#${service?.slug}`}
                        scroll={(el) =>
                          el.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          })
                        }
                      >
                        <div onClick={() => setCurrentService(service?.slug)}>
                          <h2>{service.title}</h2>
                        </div>
                      </HashLink>
                    ))}
                    {filteredBlogs?.map((blog, index) => (
                      <Link key={"blog-" + index} to={`/news/${blog.slug}`}>
                        <div><h2>{blog.title}</h2></div>
                      </Link>
                    ))}
                  </>
                ) : (
                  <h2 className="noFound">No results found.</h2>
                )}
              </div>
            </div>

            <div className="lang">
              <button
                className="currentLang"
                onClick={() => setIsLanguageDropdownOpen(!isLanguageDropdownOpen)}
                aria-haspopup="listbox"
                aria-expanded={isLanguageDropdownOpen}
              >
                <img loading="lazy" src={selectedLanguage.flag} alt={`${selectedLanguage.name} flag`} className="flag" />
                <div className="langtxt">{selectedLanguage.code}</div>
              </button>
              {isLanguageDropdownOpen && (
                <ul className="otherlangs" role="listbox">
                  {languages.map((lng) => (
                    <li key={lng.code}>
                      <button
                        className="langItem"
                        onClick={() => handleLanguageChange(lng)}
                        role="option"
                        aria-selected={lng.code === selectedLanguage.code}
                      >
                        <img src={lng.flag} alt={`${lng.name} flag`} className="flag" />
                        {lng.name}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
